module.exports = __webpack_public_path__ + "img/Arabic-02.2c612d24.jpg";